import moment from "moment-jalaali";

export const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};

export const isInStandaloneMode = () =>
    window.matchMedia('(display-mode: standalone)').matches;

// 'standalone' in window.navigator && window.navigator.standalone;

// isInWebAppiOS = (window.navigator.standalone == true);

export const isInWebAppChrome = () =>
    window.matchMedia('(display-mode: standalone)').matches;

export const ConvertTMonthName = (month) =>{
    let name= "";
    switch (month) {
        case '01':
            name =  "فروردین";
            break;
        case '02':
            name =  "اردیبهشت";
            break;
        case '03':
            name =  "خرداد";
            break;
        case '04':
            name =  "تیر";
            break;
        case '05':
            name =  "مرداد";
            break;
        case '06':
            name =  "شهریور";
            break;
        case '07':
            name =  "مهر";
            break;
        case '08':
            name =  "آبان";
            break;
        case '09':
            name =  "آذر";
            break;
        case '10':
            name =  "دی";
            break;
        case '11':
            name =  "بهمن";
            break;
        case '12':
            name =  "اسفند";
            break;
        default:
            name =  "---";
    }

    return name;
}


export const
    fixNumbers = function (str)
    {
        str = str.replace(/\s+/g, '');
        let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        let arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if(typeof str === 'string')
        {
            for(let i=0; i<10; i++)
            {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

export const convertPayStatusCode = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result = "منتظر پرداخت"
            break;
        case 2:
            result = "تسویه شده"
            break;
        case 3:
            result = "منتظر تسویه"
            break;
    }
    return result
}



export const convertStatusCode = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  =  "اولیه"
            break;
        case 2:
            result  =  "آماده پرداخت"
            break;
        case 3:
            result  =  "نهایی شده توسط مشتری"
            break;
        case 5:
            result  =  "رد شده توسط صندوقدار"
            break;
        case 9:
            result  =  "شروع جمع آوری"
            break;
        case 10:
            result  =  "جمع آوری شده"
            break;
        case 13:
            result  =  "آماده ارسال"
            break;
        case 14:
            result  =  "در حال پیدا کردن پیک"
            break;
        case 15:
            result  =  "قبول شده توسط پیک"
            break;
        case 20:
            result  =  "در حال ارسال"
            break;
        case 25:
            result  =  "تحویل شده"
            break;
        case 30:
            result  =  "توسط مشتری کنسل شد"
            break;
        case 31:
            result  =  "توسط دیجیمال کنسل شد"
            break;
        case 32:
            result  =  "توسط میاره کنسل شد"
            break;
    }

    return result;

}

export const convertPayStatusStyle = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  = "#eaa55a"
            break;
        case 2:
            result  =  "#6dcd6f"
            break;
        case 3:
            result  = "#f16e31"
            break;
    }

    return result;

}


export const convertStatusStyle = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  = "#7d7d7d" // "اولیه"
            break;
        case 2:
            result  =  "#eaa55a" //"آماده پرداخت"
            break;
        case 3:
            result  = "#9cb823" // "نهایی شده توسط مشتری"
            break;
        case 5:
            result  =  "#c24d4d" // "رد شده توسط صندوقدار"
            break;
        case 9:
            result  =  "#f5c85c" // "شروع جمع آوری"
            break;
        case 10:
            result  =  "#82ad48" //"جمع آوری شده"
            break;
        case 13:
            result  =  "#64cace"  //"آماده ارسال"
            break;
        case 14:
            result  =  "#e5d24e" //"در حال پیدا کردن پیک"
            break;
        case 15:
            result  =  "#33af79"  //"قبول شده توسط پیک"
            break;
        case 20:
            result  =  "#4da8d9" //"در حال ارسال"
            break;
        case 25:
            result  = "#62db64" // "تحویل شده"
            break;
        case 30:
            result  =  "#d05a5a" //"توسط مشتری کنسل شد"
            break;
        case 31:
            result  =  "#d05a5a" //"توسط دیجیمال کنسل شد"
            break;
        case 32:
            result  =  "#d05a5a" //"توسط میاره کنسل شد"
            break;
    }

    return result;

}


export const ConvertToJalaliSplited = (date) =>{
    if(date){
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        let hh = moment.utc(date.split('+')[0]).format('HH');
        let mm = moment.utc(date.split('+')[0]).format('mm');
        return {month,year,day,hh,mm}
    }
}

export const ConvertToJalaliSplitedString = (date) =>{
    if(date){
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        let hh = moment.utc(date.split('+')[0]).format('HH');
        let mm = moment.utc(date.split('+')[0]).format('mm');
        return day+" "+month+""+year+" - "+hh+":"+mm
    }else {
        return "-/-/-  -:-"
    }
}



export function numberWithCommas(x) {
    // convert To toman
    // x= (x/10).toFixed(0)
    //add commas
    if(x){
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }else {
        return "0"
    }
}
